import React from 'react';
import Index from './Index';
import IncomeStatementView from '../components/views/IncomeStatementView';
import { modules } from '../config/const';

function IncomeStatementPage() {
  return <Index content={IncomeStatementView} module={modules.IncomeStatement} />;
}

export default IncomeStatementPage;
